import { NAME } from './constants';
import { PARTNER_TYPE } from './store/types';
import { apiProvider } from './api';
import { router } from './router';
import Select from './components/Select.vue';

export const Partner = {
	name: NAME,
	apiProvider,
	router,
	types: PARTNER_TYPE,
	components: {
		Select,
	},
};
